(function ClientLeadFormsClientsReport($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/ClientLeadForms/clientsReport/', function onload()
		{
			$('.view-client-comments').on('click', function onViewClick(e)
			{
				var id     = $(this).data('client-id');
				var $modal = $('.modal');

				e.preventDefault();

				$modal.find('.modal-title').text('Client Comments');

				Adzuki.Ajax.get('/ClientLeadForms/clientComments/' + id)
				.then(function viewForm(response) {
					$modal.find('.modal-body').html(response);
					$modal.modal('show');
				});
			});
		});
	});
}(jQuery, window.Adzuki || {}));